module.exports = {
          srcSet: __webpack_public_path__ + "5adf0e86a2c952f82447466799c1becc-707.png"+" 707w",
          images:[ {path: __webpack_public_path__ + "5adf0e86a2c952f82447466799c1becc-707.png",width: 707,height: 936}],
          src: __webpack_public_path__ + "5adf0e86a2c952f82447466799c1becc-707.png",
          toString:function(){return __webpack_public_path__ + "5adf0e86a2c952f82447466799c1becc-707.png"},
          
          width: 707,
          height: 936
        }